import { T } from "components/util/t";
import { Notification } from "../notifications/Notification";
import { makeStyles } from "../../providers/makeStyles";
import { Typography } from "@mui/material";
import { ArrowOutward } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { UnorderedList } from "../lists/UnorderedList";

const useStyles = makeStyles(theme => ({
    notification: {
        "&& span a": {
            fontWeight: theme.typography.body1.fontWeight
        }
    }
}));

const getExclusiveLinks = exclusiveSeries => exclusiveSeries.map(series => ({
    link: `/${series.organisation.shortName}/series/${series.id}/sign-on`,
    name: `${series.name} (${series.organisation.name})`
}));

export const MembershipRequiredNotification = ({ exclusiveSeries, organisation, children }) => {
    const classes = useStyles();

    return (
        <Notification
            type="info"
            className={classes.notification}
            text={<T links={getExclusiveLinks(exclusiveSeries)} contactEmail={organisation.contactEmail}>{children}</T>}
        />
    );
};

export const MembershipRequiredMessage = ({ exclusiveSeries, organisation }) => (
    <>
        <T>Looking to enter a different athlete? This event requires membership to enter, so you'll need to purchase those first.</T>
        <UnorderedList>
            {getExclusiveLinks(exclusiveSeries).map((link, i) =>
                <li key={i}>
                    <Typography to={link.link} component={Link} target="_blank" rel="noreferrer" sx={{ textDecoration: "underline" }}>{link.name}</Typography>
                    <ArrowOutward fontSize="inherit" />
                </li>
            )}
        </UnorderedList>
    </>
);
